import { Space as BriqCommonSpace } from '@briq/shared'

export type SpaceProps = BriqCommonSpace.SpaceProps

export const Space = BriqCommonSpace.Space
